<div class="container-fluid row_banner">
  <app-header></app-header>
  <!-- <header></header> -->
  <h1 class="terms-title">Privacy Policy</h1>
  <div class="container terms-container">
    <div class="row row_banner_1">
      <div class="container">
        <div
          class="row py-3 mt-2 justify-content-center"
          style="align-content: justify"
        >
          <div class="plag_benefit w-100 px-3 pt-3">
            <span class="terms" style="margin-top: 70px">Privacy</span>
            <br />
            <br />
            <p class="detail">
              Welcome to Grammarin! We prioritize your privacy and are committed
              to safeguarding your personal data. This privacy policy outlines
              how Grammarin collects, uses, and protects the information you
              share with us when using our products or services. Our team aims
              to provide a secure environment while enhancing your experience
              with personalized features. By using Grammarin, you provide your
              consent to the data practices described here, and we encourage you
              to review this policy to understand your rights and choices
              regarding your information.
            </p>
            <br />
            <span class="terms">Information Collection </span>
            <br />
            <br />
            <p class="detail" style="word-wrap: break-word">
              To enhance your experience with Grammarin, we collect various
              types of information:
            </p>
            <ul class="detail">
              <li>
                <b>Account Information:</b> Details like name and email address,
                used to manage your account and personalize services.
              </li>
              <li>
                <b>Payment Information:</b> Billing data to process
                subscriptions or purchases securely.
              </li>
              <li>
                <b>Log Data and Device Information:</b>Data from device types,
                operating systems, and IP addresses to optimize compatibility
                and troubleshoot issues.
              </li>
              <li>
                <b>Sales and Support Data: </b> Information from customer
                interactions to improve services and support.
              </li>
              <li>
                <b>User Content: </b> Text input and documents submitted to
                <a class="aTag" href="/grammar-checker"> check grammar</a> and
                style analysis.
              </li>
              <li>
                <b>Usage Data: </b> Insights into feature interactions and
                preferences for service optimization.
              </li>
              <li>
                <b>Cookie Information and Other Identifiers: </b> Cookies and
                similar identifiers to track user sessions, preferences, and
                enhance functionality.
              </li>
            </ul>
            <br />
            <span class="terms">Use of Collected Information</span>
            <br />
            <br />
            <p class="detail">
              <a
                [routerLink]="['/']"
                style="text-decoration: none; color: black"
                >Grammarin</a
              >
              uses the information we collect to provide, improve, and
              personalize our services for each user, as outlined below:
            </p>

            <br />
            <ul class="detail">
              <li>
                <b>Service Functionality and Optimization: </b> Account
                information and user content enable core functionality, allowing
                us to deliver real-time grammar, style, and language
                improvements. Usage data and log data help us optimize tool
                performance and ensure compatibility across devices and
                operating systems.
              </li>
              <li>
                <b>Personalization:</b>To enhance user experience, we analyze
                usage data and preferences. This allows us to recommend
                features, adjust settings, and personalize insights based on
                each user’s interaction patterns.
              </li>
              <li>
                <b>Security and Fraud Prevention:</b> Device and log information
                help us monitor, detect, and prevent unauthorized access,
                account misuse, or potentially harmful activities, ensuring a
                safe experience for all users.
              </li>
              <li>
                <b>Customer Support and Issue Resolution: </b> Sales and support
                data allow us to assist with account-related inquiries,
                troubleshoot issues, and improve response efficiency, providing
                a tailored support experience.
              </li>
              <li>
                <b>Payment Processing and Billing: </b> We use payment
                information to securely process subscriptions and purchases.
                Grammarin adheres to strict data protection standards to keep
                payment details confidential and prevent unauthorized access.
              </li>
              <li>
                <b>Service Improvements and Development: </b> Analyzing usage
                patterns helps us understand feature popularity, user pain
                points, and improvement opportunities. This feedback informs our
                ongoing development and enables us to introduce relevant
                updates.
              </li>
              <li>
                <b>Cookie Information and Other Identifiers: </b> Cookies and
                similar identifiers support various aspects of the user journey,
                from login sessions to remembering preferences and enabling
                features. Additionally, tracking data allows us to evaluate site
                performance and user navigation patterns, helping us refine
                services based on behavioral insights
              </li>
              <li>
                <b>Compliance with Legal Requirements: </b> <a class="aTag" href="/"> Grammarin </a> may use
                collected information as necessary to comply with applicable
                laws and regulations, including disclosures requested by lawful
                authorities.
              </li>
            </ul>
            <br />
            <span class="terms">Data Sharing and Disclosure</span>
            <br />
            <br />
            <p class="detail">
              Grammarin values your privacy and takes measures to limit data
              sharing to essential circumstances:
            </p>

            <br />
            <ul class="detail">
              <li>
                <b>Third-Party Service Providers: </b> We partner with reputable
                third-party vendors to help deliver and improve our services,
                such as payment processors, analytics providers, and customer
                support platforms. These providers access data only as necessary
                and are bound by strict confidentiality agreements.
              </li>
              <li>
                <b>Legal Compliance and Protection:</b>We may disclose
                information if required to comply with legal obligations, such
                as a court order, subpoena, or government investigation.
                <a
                  [routerLink]="['/']"
                  style="text-decoration: none; color: black"
                  >Grammarin</a
                >
                also reserves the right to share information if we believe it is
                necessary to protect our rights, safety, or property, as well as
                that of our users and the public.
              </li>
              <li>
                <b>Business Transfers:</b> In the event of a merger,
                acquisition, restructuring, or sale of assets, user data may be
                transferred or disclosed to involved parties. Should such a
                change occur, we will notify users and explain any new policies
                or data practices..
              </li>
              <li>
                <b>Aggregate or Anonymized Data: </b> Grammarin may share
                aggregate or anonymized data that cannot be used to identify
                individual users. This type of data helps us improve our
                services, conduct market research, and collaborate with partners
                without compromising user privacy.
              </li>
              <li>
                <b>User Consent: </b> With your explicit consent, we may share
                information for specific purposes not covered in this policy.
                This ensures that data is only shared when the user has agreed
                to such use.
              </li>
            </ul>
            <br /><br />
            <span class="terms">Data Security</span>
            <br />
            <br />
            <p class="detail">
              At Grammarin, we prioritize the security of your personal
              information and employ robust measures to protect it against
              unauthorized access, alteration, or disclosure. We implement
              industry-standard security technologies, including encryption,
              firewalls, and secure server environments, to safeguard data
              during transmission and storage. Regular security audits and
              assessments help us identify and address potential
              vulnerabilities.
            </p>
            <p class="detail">
              Access to your information is restricted to authorized personnel
              only, who are trained in data protection practices. While we
              strive to maintain the highest security standards, it is important
              to understand that no method of transmission over the internet or
              electronic storage is completely secure. Consequently, we cannot
              guarantee absolute security.
            </p>
            <p class="detail">
              We encourage users to adopt their own security practices, such as
              using strong passwords and keeping account details confidential.
              If a data breach occurs, we will promptly inform affected users
              and take appropriate action to mitigate any potential impact.
            </p>
            <br />
            <span class="terms"> User Rights and Choices</span>
            <br />
            <br />
            <p class="detail">
              At Grammarin, we empower users to manage their personal data and
              exercise control over their information. You have the right to
              access, update, and correct your account information at any time
              through your profile settings. If you wish to delete your data or
              stop using our services, you can request data deletion, after
              which we will remove your information from our systems, barring
              data retained for legal compliance or legitimate business
              purposes. You also have the right to request a copy of your data,
              a practice known as data portability, allowing you to transfer
              your information to another service. Additionally, Grammarin
              provides opt-out options for data collection features, such as
              personalized analytics or marketing communications, which can be
              managed through your account settings or by contacting our support
              team. By giving users full transparency and control, we ensure
              that your data is used in alignment with your preferences.
            </p>

            <br />
            <span class="terms"> Cookies and Tracking</span>
            <br />
            <br />
            <p class="detail">
              Grammarin uses cookies and similar tracking technologies to
              improve user experience, enhance functionality, and analyze site
              performance. Cookies help us remember login sessions, store
              preferences, and tailor our features to each user’s needs. We may
              also use these technologies to gather insights into user behavior,
              which allows us to refine our services over time. Users can
              control or disable cookies through their browser settings;
              however, some features may be limited without cookie
              functionality.
            </p>
            <br />
            <span class="terms"> Contact Information</span>
            <br />
            <br />
            <p class="detail">
              If you have questions, concerns, or requests related to this
              privacy policy or how your data is handled, please reach out to
              our dedicated support team. We’re here to assist with privacy
              inquiries, data access requests, and account management.
            </p>

            <br />
            <span class="terms-cont">Contact us at: </span>
            <br />
            <br />
            <p class="detail">
              <b>Email:</b>
              <a
                href="mailto:support@grammarin.com"
                style="text-decoration: none; color: black"
                >support&#64;grammarin.com</a
              >
            </p>
            <p class="detail"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>
<app-footer></app-footer>
